const PUBLIC_PATHS = [
  /^\/analytics(?:\/|$)/,
  /^\/auth\/(?:login|test)(?:\/|$)/,
  /^\/consent(?:\/|$)/,
  /^\/legal(?:\/|$)/,
];

const PUBLIC_GET_PATHS = [
  /^\/bootstrap(?:\/|$)/,
  /^\/content(?:\/|$)/,
  /^\/presets(?:\/|$)/,
  /^\/preset-groups(?:\/|$)/,
  /^\/preset-examples(?:\/|$)/,
  /^\/prompt-carousel(?:\/|$)/,
  /^\/generate\/(?:presets|base-presets)(?:\/|$)/,
  /^\/credits\/packages(?:\/|$)/,
  /^\/subscription\/plans(?:\/|$)/,
];

const PUBLIC_MUTATIONS = [
  {
    method: 'PATCH',
    path: /^\/user\/profile$/,
  },
];

const PROTECTED_PATHS = [
  /^\/auth\/profile(?:\/|$)/,
  /^\/auth\/(?:change-plan|plan-info)(?:\/|$)/,
  /^\/credits(?:\/|$)/,
  /^\/generate(?:\/|$)/,
  /^\/gallery(?:\/|$)/,
  /^\/history(?:\/|$)/,
  /^\/prompt-helper(?:\/|$)/,
  /^\/referral(?:\/|$)/,
  /^\/share(?:\/|$)/,
  /^\/subscription(?:\/|$)/,
  /^\/upload(?:\/|$)/,
  /^\/user(?:\/|$)/,
  /^\/video(?:\/|$)/,
];

let consentRequiredState = null;
let previousConsentAccessState = false;

export function setConsentRequiredState(value, { versionChanged = false } = {}) {
  consentRequiredState = value === true ? true : value === false ? false : null;
  previousConsentAccessState = consentRequiredState === true && versionChanged === true;
}

export function getConsentRequiredState() {
  return consentRequiredState;
}

export function hasRequiredConsent() {
  return consentRequiredState === false;
}

export function hasPreviousConsentAccess() {
  return previousConsentAccessState;
}

export function canRequestProtectedResource(policy) {
  if (!policy?.protected) return true;
  if (hasRequiredConsent()) return true;
  return (
    previousConsentAccessState
    && policy.kind === 'data'
    && policy.path === '/credits/balance'
  );
}

export function normalizeApiPath(url = '') {
  const raw = String(url || '');
  try {
    return new URL(raw, 'https://local.invalid').pathname.replace(/^\/api(?=\/|$)/, '') || '/';
  } catch {
    return raw.split('?')[0].replace(/^\/api(?=\/|$)/, '') || '/';
  }
}

export function getConsentRequestPolicy(config = {}) {
  const method = String(config.method || 'get').toUpperCase();
  const path = normalizeApiPath(config.url);

  if (PUBLIC_PATHS.some((pattern) => pattern.test(path))) {
    return { protected: false, kind: 'public', path };
  }

  if (method === 'GET' && PUBLIC_GET_PATHS.some((pattern) => pattern.test(path))) {
    return { protected: false, kind: 'public', path };
  }

  if (PUBLIC_MUTATIONS.some((entry) => (
    entry.method === method && entry.path.test(path)
  ))) {
    return { protected: false, kind: 'public', path };
  }

  if (PROTECTED_PATHS.some((pattern) => pattern.test(path))) {
    return {
      protected: true,
      kind: method === 'GET' ? 'data' : 'action',
      path,
    };
  }

  return { protected: false, kind: 'public', path };
}

export function inferConsentTrigger(path = '') {
  if (path.includes('/prompt-helper')) return 'prompt_helper';
  if (path.includes('/credits/') || path.includes('/subscription/')) return 'purchase';
  if (path.includes('/upload/')) return 'upload';
  return 'generate';
}

export function sanitizeBootstrapAccountData(data, consentRequired = consentRequiredState) {
  if (!data || consentRequired === false) return data;
  return {
    ...data,
    user: null,
    credits: null,
    subscription: null,
    accountDataAvailable: false,
  };
}

export function __resetConsentPolicyForTests() {
  consentRequiredState = null;
  previousConsentAccessState = false;
}
